export default class SafeMath {
    static divide(dividend: number, divisor: number): number {
        return divisor > 0 ? dividend / divisor : 0;
    }

    static equal(operand1: number, operand2: number): boolean {
        return Math.abs(operand1 - operand2) < Number.EPSILON;
    }
}